// src/Components/templates/HomePage/index.tsx

import React, { useEffect, useRef, useState } from "react";
import { Section } from "Components/atoms/Section";
import { AccordionInfoTemplate } from "Components/templates/AccordionInfo";
import { CallToActionBlockTemplate } from "Components/templates/CallToActionBlock";
import { FooterTemplate } from "Components/templates/FooterTemplate";
import { HeaderTemplate } from "Components/templates/Header";
import { HeroTemplate } from "Components/templates/HeroSection";
import { PromotionsCarouselTemplate } from "Components/templates/PromotionsCarousel";
import { ResultsFlightsTemplate } from "Components/templates/ResultsFlights";
import { TestimonialsTemplate } from "Components/templates/TestimonialsSection";
import { theme } from "styles/theme";
import { useBreakpoint } from "shared/hooks/useBreakpoint";
import { AdBannerContainer } from "Components/molecules/AdBanner";

export function HomePage({ isSERP = false }) {
  const background = `linear-gradient(to bottom, ${theme.colors.lightBlue} -10%, rgba(0,0,0,0) 100%)`;
  const resultsFlightsRef = useRef<HTMLDivElement | null>(null);
  const breakpoint = useBreakpoint();
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    setMobile(breakpoint !== "xxl");
  }, [breakpoint]);

  useEffect(() => {
    if (isSERP) {
      if (breakpoint === "xs" || breakpoint === "sm" || breakpoint === "md") {
        const interval = setInterval(() => {
          const headerFilter = document.querySelector("#header-filter-mobile");
          if (headerFilter) {
            headerFilter.scrollIntoView({ behavior: "smooth", block: "start" });
            clearInterval(interval);
          }
        }, 100);
      } else if (resultsFlightsRef.current) {
        resultsFlightsRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [isSERP, breakpoint]);

  return (
    <div className="App">
      {/* Cabeçalho */}
      <HeaderTemplate />

      {/* Seção Hero */}
      <HeroTemplate />

      {/* Resultados de Voos */}
      {isSERP && (
        <Section
          ref={resultsFlightsRef}
          sectionId="results-flights"
          backgroundColor={background}
          isVisible={isSERP}
          maxWidth={1624}
        >
          <ResultsFlightsTemplate />

          {isMobile ? (
            <>
              <AdBannerContainer
                slotId="div-gpt-ad-1748863177264-0"
                adUnit="/27140001/300x250_FlightsearchMob"
                sizes={[[300, 250]]}
                marginTop={30}
              />
              <AdBannerContainer
                slotId="div-gpt-ad-1748863270568-0"
                adUnit="/27140001/320x50_flightsearch"
                sizes={[
                  [300, 50],
                  [300, 100],
                  [234, 60],
                  [320, 100],
                  [320, 50],
                ]}
                marginTop={30}
              />
            </>
          ) : (
            <AdBannerContainer
              slotId="div-gpt-ad-1748863775645-0"
              adUnit="/27140001/2024-home-desktop-footer-970x90"
              sizes={[[970, 90]]}
              marginTop={30}
            />
          )}
        </Section>
      )}

      {/* Outras Seções */}
      <Section backgroundColor={background} maxWidth={1624} isVisible={!isSERP}>
        <PromotionsCarouselTemplate />
        <CallToActionBlockTemplate />
        {/* <TestimonialsTemplate /> */}
        <AccordionInfoTemplate />
      </Section>

      {/* Rodapé */}
      <FooterTemplate />
    </div>
  );
}
